import { h } from 'preact';

import LandingPageEditor from 'components/editor/movies/landing/landing';

import s from 'components/editor/movies/landing/landingUniversal.sss';

export default class UniversalLandingPageEditor extends LandingPageEditor {
	s = s;

	getLandingPageSections() {
		const sections = super.getLandingPageSections();
		const pagesData = this.movie?.pages;

		return sections
			.filter(page => pagesData?.[page]?.active)
			.sort((a, b) => (pagesData?.[a].order ?? 999) - (pagesData?.[b].order ?? 999));
	}
}